(() => {
  'use strict';

  function renderDiscovery(root, catalog) {
    const filters = root.querySelector('.usac-power-discovery__filters');
    const results = root.querySelector('.usac-power-discovery__results');
    const readyFilters = (catalog.filters || []).filter((filter) => filter.readyForCustomerFilter);
    const selected = {};

    for (const filter of readyFilters) {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'usac-source-discovery__filter';
      const legend = document.createElement('legend');
      legend.textContent = filter.label;
      const options = document.createElement('div');
      options.className = 'usac-source-discovery__filter-options';
      for (const value of filter.values) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'usac-source-discovery__filter-chip';
        chip.textContent = value;
        chip.setAttribute('aria-pressed', 'false');
        chip.addEventListener('click', () => {
          selected[filter.key] = selected[filter.key] === value ? '' : value;
          [...options.children].forEach((button) => button.setAttribute('aria-pressed', String(button.textContent === selected[filter.key])));
          update();
        });
        options.appendChild(chip);
      }
      fieldset.append(legend, options);
      filters.appendChild(fieldset);
    }

    function update() {
      const matches = catalog.candidates.filter((candidate) => Object.entries(selected)
        .every(([key, value]) => !value || candidate.attributes[key] === value));
      results.replaceChildren();
      const status = document.createElement('div');
      status.className = 'usac-power-discovery__status';
      status.textContent = matches.length + ' source-classified WAGO power supplies match your requirements.';
      results.appendChild(status);
      for (const candidate of matches.slice(0, 80)) {
        const row = document.createElement('div');
        row.className = 'usac-power-discovery__result';
        const link = document.createElement('a');
        link.href = '/products/' + candidate.handle;
        link.textContent = candidate.title;
        const sku = document.createElement('span');
        sku.textContent = 'Part # ' + candidate.sku;
        const specs = document.createElement('span');
        specs.className = 'usac-power-discovery__result-specs';
        const electricalValues = [
          candidate.attributes.output_power ? 'Power: ' + candidate.attributes.output_power : '',
          candidate.attributes.output_current ? 'Current: ' + candidate.attributes.output_current : '',
        ].filter(Boolean);
        specs.textContent = electricalValues.join(' · ');
        row.append(link, sku, specs);
        results.appendChild(row);
      }
      if (matches.length > 80) {
        const more = document.createElement('div');
        more.className = 'usac-power-discovery__status';
        more.textContent = 'Refine one more electrical requirement to narrow the first 80 matching products.';
        results.appendChild(more);
      }
    }

    update();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-usac-wago-power-discovery]').forEach(async (root) => {
      try {
        const response = await fetch(root.dataset.catalogUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unable to load the WAGO power catalog.');
        renderDiscovery(root, await response.json());
      } catch {
        root.querySelector('.usac-power-discovery__results').textContent = 'Power-supply filters are temporarily unavailable. Please search an exact part number or contact USAC for selection help.';
      }
    });
  });
})();